var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/24px/Mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 1.36548H5C3.67441 1.36707 2.40356 1.89436 1.46622 2.8317C0.528882 3.76904 0.00158786 5.03988 0 6.36548L0 18.3655C0.00158786 19.6911 0.528882 20.9619 1.46622 21.8993C2.40356 22.8366 3.67441 23.3639 5 23.3655H19C20.3256 23.3639 21.5964 22.8366 22.5338 21.8993C23.4711 20.9619 23.9984 19.6911 24 18.3655V6.36548C23.9984 5.03988 23.4711 3.76904 22.5338 2.8317C21.5964 1.89436 20.3256 1.36707 19 1.36548ZM5 3.36548H19C19.5988 3.36666 20.1835 3.54699 20.679 3.88328C21.1744 4.21957 21.5579 4.69643 21.78 5.25248L14.122 12.9115C13.5584 13.4728 12.7954 13.7879 12 13.7879C11.2046 13.7879 10.4416 13.4728 9.878 12.9115L2.22 5.25248C2.44215 4.69643 2.82561 4.21957 3.32105 3.88328C3.81648 3.54699 4.40121 3.36666 5 3.36548ZM19 21.3655H5C4.20435 21.3655 3.44129 21.0494 2.87868 20.4868C2.31607 19.9242 2 19.1611 2 18.3655V7.86548L8.464 14.3255C9.40263 15.2617 10.6743 15.7875 12 15.7875C13.3257 15.7875 14.5974 15.2617 15.536 14.3255L22 7.86548V18.3655C22 19.1611 21.6839 19.9242 21.1213 20.4868C20.5587 21.0494 19.7956 21.3655 19 21.3655Z",
    fill: "#152FF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMail);
export default __webpack_public_path__ + "static/media/ic_mail.86ec70176ff4817080179d6869740fbf.svg";
export { ForwardRef as ReactComponent };